const Landing = () => {
    return (
        <div className="page">
            <h1>Welcome to Propex :D</h1>
        </div>
    )
}

export default Landing